import { AlertTriangle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useI18n } from '@/i18n'

interface AuthLoopPageProps {
    onTryAgain: () => void
    onLogoutFully: () => void
}

export function AuthLoopPage({ onTryAgain, onLogoutFully }: AuthLoopPageProps) {
    const i18n = useI18n()
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/95 backdrop-blur-sm">
            <div className="flex flex-col items-center gap-4 text-center p-8 max-w-md">
                <div className="rounded-full bg-status-warning-subtle p-4 dark:bg-status-warning-subtle/30">
                    <AlertTriangle className="h-12 w-12 text-status-warning dark:text-status-warning-muted" />
                </div>
                <h2 className="text-2xl font-semibold tracking-tight" data-testid="auth-loop-title">
                    {i18n.auth.loopBreak.title}
                </h2>
                <p className="text-muted-foreground">
                    {i18n.auth.loopBreak.description}
                </p>
                <div className="flex gap-3 mt-2">
                    <Button onClick={onTryAgain} data-testid="auth-loop-try-again">
                        {i18n.auth.loopBreak.tryAgain}
                    </Button>
                    <Button variant="outline" onClick={onLogoutFully} data-testid="auth-loop-logout-fully">
                        {i18n.auth.loopBreak.logoutFully}
                    </Button>
                </div>
            </div>
        </div>
    )
}
